import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'

import 'element-ui/lib/theme-chalk/reset.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
// import 'style/index.scss'

Vue.config.productionTip = false

Vue.use(ElementUI, {
  size: 'medium' // set element-ui default size
})

router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  /* 未登录跳转 */
  if (!userInfo && to.name !== 'login') {
    if (to.name !== 'trace' && to.name !== 'printer') {
      next({ name: 'login' })
    }
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

// 解决刷新时，仍然打开当前页但是没有tab的问题
let userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
if (userInfo) {
  console.log(router)
  console.log(router.history.current.name)
  // if (router.history.current.name !== 'printer') {
  //   router.push({ name: 'index' })
  // }
}
